export default __webpack_public_path__ + "static/media/pet-images-02.22da6367.jpg";